/* tslint:disable */
import {
  PaymentMethods,
  Lease
} from '../index';

declare var Object: any;
export interface CreditNoteInterface {
  "management_company_id"?: number;
  "lease_id": number;
  "amount": number;
  "payment_status": string;
  "description"?: string;
  "date_paid"?: Date;
  "payment_method"?: number;
  "chart_of_account_id"?: number;
  "payment_reference"?: string;
  "tag"?: string;
  "charged_to"?: string;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  paymentMethod?: PaymentMethods;
  lease?: Lease;
}

export class CreditNote implements CreditNoteInterface {
  "management_company_id": number;
  "lease_id": number;
  "amount": number;
  "payment_status": string;
  "description": string;
  "date_paid": Date;
  "payment_method": number;
  "chart_of_account_id": number;
  "payment_reference": string;
  "tag": string;
  "charged_to": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  paymentMethod: PaymentMethods;
  lease: Lease;
  constructor(data?: CreditNoteInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `CreditNote`.
   */
  public static getModelName() {
    return "CreditNote";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of CreditNote for dynamic purposes.
  **/
  public static factory(data: CreditNoteInterface): CreditNote{
    return new CreditNote(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'CreditNote',
      plural: 'CreditNotes',
      path: 'CreditNotes',
      idName: 'id',
      properties: {
        "management_company_id": {
          name: 'management_company_id',
          type: 'number'
        },
        "lease_id": {
          name: 'lease_id',
          type: 'number'
        },
        "amount": {
          name: 'amount',
          type: 'number'
        },
        "payment_status": {
          name: 'payment_status',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "date_paid": {
          name: 'date_paid',
          type: 'Date'
        },
        "payment_method": {
          name: 'payment_method',
          type: 'number'
        },
        "chart_of_account_id": {
          name: 'chart_of_account_id',
          type: 'number'
        },
        "payment_reference": {
          name: 'payment_reference',
          type: 'string'
        },
        "tag": {
          name: 'tag',
          type: 'string'
        },
        "charged_to": {
          name: 'charged_to',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        paymentMethod: {
          name: 'paymentMethod',
          type: 'PaymentMethods',
          model: 'PaymentMethods',
          relationType: 'belongsTo',
                  keyFrom: 'payment_method',
          keyTo: 'id'
        },
        lease: {
          name: 'lease',
          type: 'Lease',
          model: 'Lease',
          relationType: 'belongsTo',
                  keyFrom: 'lease_id',
          keyTo: 'id'
        },
      }
    }
  }
}
